/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlytzcollectAnalyticsRouteImport } from './routes/blytzcollect/analytics'
import { Route as CsToolsAutopayAccountsRouteImport } from './routes/cs-tools/autopay-accounts'
import { Route as PaymentsAchReturnsRouteImport } from './routes/payments/ach-returns'
import { Route as PaymentsBinMccFeeReportRouteImport } from './routes/payments/bin-mcc-fee-report'
import { Route as ReportsRetryAnalysisRouteImport } from './routes/reports/retry-analysis'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlytzcollectAnalyticsRoute = BlytzcollectAnalyticsRouteImport.update({
  id: '/blytzcollect/analytics',
  path: '/blytzcollect/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const CsToolsAutopayAccountsRoute = CsToolsAutopayAccountsRouteImport.update({
  id: '/cs-tools/autopay-accounts',
  path: '/cs-tools/autopay-accounts',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsAchReturnsRoute = PaymentsAchReturnsRouteImport.update({
  id: '/payments/ach-returns',
  path: '/payments/ach-returns',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsBinMccFeeReportRoute = PaymentsBinMccFeeReportRouteImport.update({
  id: '/payments/bin-mcc-fee-report',
  path: '/payments/bin-mcc-fee-report',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRetryAnalysisRoute = ReportsRetryAnalysisRouteImport.update({
  id: '/reports/retry-analysis',
  path: '/reports/retry-analysis',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/blytzcollect/analytics': typeof BlytzcollectAnalyticsRoute
  '/cs-tools/autopay-accounts': typeof CsToolsAutopayAccountsRoute
  '/payments/ach-returns': typeof PaymentsAchReturnsRoute
  '/payments/bin-mcc-fee-report': typeof PaymentsBinMccFeeReportRoute
  '/reports/retry-analysis': typeof ReportsRetryAnalysisRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/blytzcollect/analytics': typeof BlytzcollectAnalyticsRoute
  '/cs-tools/autopay-accounts': typeof CsToolsAutopayAccountsRoute
  '/payments/ach-returns': typeof PaymentsAchReturnsRoute
  '/payments/bin-mcc-fee-report': typeof PaymentsBinMccFeeReportRoute
  '/reports/retry-analysis': typeof ReportsRetryAnalysisRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/blytzcollect/analytics': typeof BlytzcollectAnalyticsRoute
  '/cs-tools/autopay-accounts': typeof CsToolsAutopayAccountsRoute
  '/payments/ach-returns': typeof PaymentsAchReturnsRoute
  '/payments/bin-mcc-fee-report': typeof PaymentsBinMccFeeReportRoute
  '/reports/retry-analysis': typeof ReportsRetryAnalysisRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/blytzcollect/analytics'
    | '/cs-tools/autopay-accounts'
    | '/payments/ach-returns'
    | '/payments/bin-mcc-fee-report'
    | '/reports/retry-analysis'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/blytzcollect/analytics'
    | '/cs-tools/autopay-accounts'
    | '/payments/ach-returns'
    | '/payments/bin-mcc-fee-report'
    | '/reports/retry-analysis'
  id:
    | '__root__'
    | '/'
    | '/blytzcollect/analytics'
    | '/cs-tools/autopay-accounts'
    | '/payments/ach-returns'
    | '/payments/bin-mcc-fee-report'
    | '/reports/retry-analysis'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BlytzcollectAnalyticsRoute: typeof BlytzcollectAnalyticsRoute
  CsToolsAutopayAccountsRoute: typeof CsToolsAutopayAccountsRoute
  PaymentsAchReturnsRoute: typeof PaymentsAchReturnsRoute
  PaymentsBinMccFeeReportRoute: typeof PaymentsBinMccFeeReportRoute
  ReportsRetryAnalysisRoute: typeof ReportsRetryAnalysisRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blytzcollect/analytics': {
      id: '/blytzcollect/analytics'
      path: '/blytzcollect/analytics'
      fullPath: '/blytzcollect/analytics'
      preLoaderRoute: typeof BlytzcollectAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cs-tools/autopay-accounts': {
      id: '/cs-tools/autopay-accounts'
      path: '/cs-tools/autopay-accounts'
      fullPath: '/cs-tools/autopay-accounts'
      preLoaderRoute: typeof CsToolsAutopayAccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/ach-returns': {
      id: '/payments/ach-returns'
      path: '/payments/ach-returns'
      fullPath: '/payments/ach-returns'
      preLoaderRoute: typeof PaymentsAchReturnsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/bin-mcc-fee-report': {
      id: '/payments/bin-mcc-fee-report'
      path: '/payments/bin-mcc-fee-report'
      fullPath: '/payments/bin-mcc-fee-report'
      preLoaderRoute: typeof PaymentsBinMccFeeReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/retry-analysis': {
      id: '/reports/retry-analysis'
      path: '/reports/retry-analysis'
      fullPath: '/reports/retry-analysis'
      preLoaderRoute: typeof ReportsRetryAnalysisRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BlytzcollectAnalyticsRoute: BlytzcollectAnalyticsRoute,
  CsToolsAutopayAccountsRoute: CsToolsAutopayAccountsRoute,
  PaymentsAchReturnsRoute: PaymentsAchReturnsRoute,
  PaymentsBinMccFeeReportRoute: PaymentsBinMccFeeReportRoute,
  ReportsRetryAnalysisRoute: ReportsRetryAnalysisRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
